import { render } from "./FooterComp.vue?vue&type=template&id=3bd85b8c&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=3bd85b8c&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd85b8c"]])

export default __exports__